module.exports = __webpack_public_path__ + "img/logo-planet-coaster.2e8a8f78.svg";